import Axios from '@/axios';

// 查询操作日志
export const getOperationLogs = params => {  
  return Axios({
    url: '/face/web/log/index_operation_logs',
    method: 'GET',
    type: 'json',
    params
  })
}

// 查询设备工作日志
export const getWorkLogs = params => {  
  return Axios({
    url: '/face/web/log/index_device_work_logs',
    method: 'GET',
    type: 'json',
    params
  })
}

// 查询数据同步日志
export const getSyncLogs = params => {  
  return Axios({
    url: '/face/web/log/index_device_sync_logs',
    method: 'GET',
    type: 'json',
    params
  })
}